import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const THEMES = ['light', 'dark', 'madivladi', 'system'] as const;
export type Theme = (typeof THEMES)[number];

interface ThemeState {
  readonly theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'light',
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'theme-storage',
    }
  )
);
